import React, { useState } from 'react';
import EventImage from '../../../event-create/components/step-1/eventImage';
import { uploadImage } from '../../../event-create/api';
import { IMAGE_TAGS } from '../../../../constants/imageTags';
import { generateUniqueId } from '../../../../utils/commonUtils';

const Image = ({formData, onChange, eventImagesRef, isEventImageUploading, readOnly, eventId }) => {

  const onChangeImageData = (data) => {

    if (data?.full_image === null && !eventImagesRef?.current?.full_image) {
      onChange({
        ...data,
        full_image: null,
        image: null,
      }, 'Image Deleted');
      return; 
    }

    if (eventImagesRef.current) {
      Promise.all([
        uploadImage({ id: formData?.full_image, image: eventImagesRef.current.full_image, tag: IMAGE_TAGS.EVENT_IMAGE, fileName: `${eventId || generateUniqueId()}_${IMAGE_TAGS.EVENT_IMAGE}`, loaderId: 'event-image-upload' }),
        uploadImage({ id: formData?.image, image: eventImagesRef.current.image, tag: IMAGE_TAGS.EVENT_CROP_IMAGE, fileName: `${eventId || generateUniqueId()}_${IMAGE_TAGS.EVENT_CROP_IMAGE}`, loaderId: 'event-image-upload' }),
      ]).then((resp) => {
        onChange({
          ...data,
          full_image: resp[0]?.data?.data?.url,
          image: resp[1]?.data?.data?.url,
        }, 'Image Updated');
      });
    }
  };

  return (
    <div className='pt-[36px] px-[80px] flex flex-col gap-9'>
      <h1 className='heading-24'>Event image</h1>
      <div className='flex flex-col'>
        <EventImage 
          showHeader={false}
          formData={formData}
          setFormData={onChangeImageData}
          enableDelete={false}
          eventImagesRef={eventImagesRef}
          isEventImageUploading={isEventImageUploading}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
};

export default Image;
